import React from 'react';
import { flow, has, map } from 'lodash';
import { connect } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import MetaInfoItem from './components/MetaInfoItem';
import Box from '../../../../common/components/Box/Box';
import Loader from '../../../../common/components/Loader/Loader';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { actions } from '../../redux/contentActions';
import SelectField from '../../../../common/components/ReduxFormField/SelectField';
import './style.scss';
import { bindActionCreators } from 'redux';

class MetaInfo extends React.Component {
  componentWillMount() {
    const { dispatch, change, actions } = this.props;
    actions.clearMetaInfo();
    actions.getContentForMetaInfo();
    dispatch(change('optionType', 'pages'));
  }

  renderMetaInfoFields = (item) => {
    return <MetaInfoItem item={item} key={item.id} fieldKey={item.id} />;
  };

  renderFieldsController = () => {
    const {
      content: { metaInfo },
      optionType,
    } = this.props;
    if (metaInfo && has(metaInfo, optionType)) {
      return map(metaInfo[optionType], (item) => this.renderMetaInfoFields(item));
    } else {
      return <Loader />;
    }
  };

  render() {
    return (
      <Box className="meta-management-box">
        <Row className="meta-type-select">
          <Col sm={3}>
            <Field
              name={'optionType'}
              fieldSize={7}
              component={SelectField}
              options={[
                { value: 'pages', label: 'Pages' },
                { value: 'brands', label: 'Brands' },
                { value: 'blogs', label: 'Blogs' },
              ]}
            />
          </Col>
        </Row>
        {this.renderFieldsController()}
      </Box>
    );
  }
}

const selector = formValueSelector('MetaInfo');
export default flow([
  reduxForm({
    form: 'MetaInfo',
  }),
  connect(
    (state) => {
      const optionType = selector(state, 'optionType');
      return {
        content: state.content,
        optionType,
      };
    },
    (dispatch) => ({
      actions: bindActionCreators(actions, dispatch),
    }),
  ),
])(MetaInfo);
